import { RecordVideo } from './RecordVideo';
export default RecordVideo;
